import { render, staticRenderFns } from "./PanelTitle.vue?vue&type=template&id=43479b49&scoped=true"
var script = {}
import style0 from "./PanelTitle.vue?vue&type=style&index=0&id=43479b49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43479b49",
  null
  
)

export default component.exports